import { useState } from "react";
import { ModalType } from "@components/modal/Modal";

const useModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalInfo, setModalInfo] = useState<{
    type: ModalType;
    title: string;
    description: string;
  } | null>(null);

  const isConfirmation = modalInfo?.type === "confirm";

  const openModal = ({
    type,
    title,
    description,
  }: {
    type: ModalType;
    title: string;
    description: string;
  }) => {
    setIsOpen(true);
    setModalInfo({ type, title, description });
  };
  const closeModal = () => {
    setIsOpen(false);
    setModalInfo(null);
  };

  return {
    isOpen,
    isConfirmation,
    modalInfo,
    openModal,
    closeModal,
  };
};

export default useModal;
